"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ExportReviewCycleReviewReportsDetailsResponse () {
        return ExportReviewCycleReviewReportsDetailsResponse;
    },
    get GetReviewCycleDetailsResponse () {
        return GetReviewCycleDetailsResponse;
    },
    get GetReviewCycleSubjectsResponse () {
        return GetReviewCycleSubjectsResponse;
    },
    get PostReviewCycleCalculateResponse () {
        return PostReviewCycleCalculateResponse;
    },
    get ReviewCycleDetailsLegacyResponse () {
        return ReviewCycleDetailsLegacyResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _generic = require("../generic");
const _reviewcycle = require("./review-cycle");
const PostReviewCycleCalculateResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetReviewCycleSubjectsResponse = _zod.z.object({
    subjects: _utilsisomorphic.transformObjectId.array()
});
const ReviewCycleDetailsLegacyResponse = _zod.z.object({
    admins_only: _zod.z.boolean(),
    cycle_name: _zod.z.string(),
    group: _zod.z.object({
        id: _zod.z.string().nullable(),
        name: _zod.z.string().nullable()
    }),
    start_date: _utilsisomorphic.transformDate,
    started: _zod.z.boolean(),
    template_id: _utilsisomorphic.transformObjectId,
    template_name: _zod.z.string()
});
const GetReviewCycleDetailsResponse = _reviewcycle.ReviewCycleDetailsModel;
const ExportReviewCycleReviewReportsDetailsResponse = _generic.GenericJobIdResponse;
